import { useState } from 'react';
import { Spinner } from '../shared/Spinner';

const PRESETS = [
  'Facture de test',
  "Ce n'est pas une facture",
  'Doublon',
] as const;

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  busy?: boolean;
}

export function DeleteModal({ open, onClose, onConfirm, busy }: Props) {
  const [choice, setChoice] = useState<(typeof PRESETS)[number] | 'autre'>(PRESETS[0]);
  const [other, setOther] = useState('');

  if (!open) return null;

  const finalReason = choice === 'autre' ? other.trim() : choice;
  const canSubmit = finalReason.length > 0 && !busy;

  return (
    <div
      className="fixed inset-0 bg-slate-900/40 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold text-slate-900">Supprimer cette facture ?</h2>
        <p className="text-sm text-slate-500 mt-1">
          Suppression définitive. Choisis une raison pour la traçabilité.
        </p>

        <div className="mt-4 space-y-2">
          {PRESETS.map((p) => (
            <label key={p} className="flex items-center gap-2 text-sm cursor-pointer">
              <input
                type="radio"
                name="delete-reason"
                checked={choice === p}
                onChange={() => setChoice(p)}
              />
              <span>{p}</span>
            </label>
          ))}
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input
              type="radio"
              name="delete-reason"
              checked={choice === 'autre'}
              onChange={() => setChoice('autre')}
            />
            <span>Autre :</span>
          </label>
          {choice === 'autre' && (
            <textarea
              autoFocus
              value={other}
              onChange={(e) => setOther(e.target.value)}
              placeholder="Précise la raison…"
              rows={2}
              className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          )}
        </div>

        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="px-3 py-1.5 rounded-md text-sm font-medium text-slate-700 hover:bg-slate-100"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={() => onConfirm(finalReason)}
            disabled={!canSubmit}
            className="px-3 py-1.5 rounded-md text-sm font-medium bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 inline-flex items-center gap-2"
          >
            {busy && <Spinner />}
            🗑️ Supprimer définitivement
          </button>
        </div>
      </div>
    </div>
  );
}
